"use strict";
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var input_1 = __importDefault(require("@blaze-react/input"));
var modal_1 = __importDefault(require("@blaze-react/modal"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var EditorViewLinkModal = function (_a) {
    var editorState = _a.editorState, onClose = _a.onClose, onSave = _a.onSave, linkContentState = _a.linkContentState;
    var _b = react_1.useState(""), url = _b[0], setUrl = _b[1];
    var _c = react_1.useState(linkContentState), componentState = _c[0], setComponentState = _c[1];
    var handleOnChange = function (_a) {
        var value = _a.value;
        return setUrl(value);
    };
    react_1.useEffect(function () {
        var selection = editorState.getSelection();
        var anchorKey = selection.getAnchorKey();
        var currentContent = editorState.getCurrentContent();
        var currentContentBlock = currentContent.getBlockForKey(anchorKey);
        var start = selection.getStartOffset();
        var end = selection.getEndOffset();
        var selectedText = currentContentBlock.getText().slice(start, end);
        if (!selection.isCollapsed() && selectedText !== "") {
            if (start !== end) {
                var blockWithLinkAtBeginning = currentContent.getBlockForKey(selection.getStartKey());
                var linkKey = blockWithLinkAtBeginning.getEntityAt(selection.getStartOffset());
                if (linkKey) {
                    var linkInstance = currentContent.getEntity(linkKey);
                    var currentUrl = linkInstance.getData().url;
                    setUrl(currentUrl);
                }
            }
        }
        if (linkContentState) {
            var contentState = linkContentState.contentState, entityKey = linkContentState.entityKey;
            var linkInstance = contentState.getEntity(entityKey);
            var currentUrl = linkInstance.getData().url;
            setUrl(currentUrl);
            setComponentState(linkContentState);
        }
    }, [editorState, linkContentState]);
    return (react_1["default"].createElement(modal_1["default"], { isAlert: true, onClose: function () {
            onClose();
        }, actions: [
            {
                textButton: "Save",
                callback: function () {
                    onSave(url, componentState);
                },
                modifiers: ["small"]
            },
        ] },
        react_1["default"].createElement(input_1["default"], { label: "Insert URL", placeholder: "Insert URL", modifier: "full-width", onChange: handleOnChange, onClick: function (e) { return e.stopPropagation(); }, value: url, autoFocus: true })));
};
EditorViewLinkModal.propTypes = {
    editorState: prop_types_1["default"].object.isRequired,
    onClose: prop_types_1["default"].func.isRequired,
    onSave: prop_types_1["default"].func.isRequired,
    linkContentState: prop_types_1["default"].object
};
EditorViewLinkModal.defaultProps = {
    linkContentState: null
};
exports["default"] = EditorViewLinkModal;
